import '../../public/css/components/AppCenter/LoggedOutHeaderFooter.less';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { recordClick, recordImpression } from '@paypalcorp/fpti-tracker';
import { getTools } from '../lib/containers';
import AppCenter from '../components/AppCenter';
import dataFetcher from './DataFetcher';
import filterPSData from '../lib/filterPSData';
import * as MyAppsActions from '../actions/myapps';
import * as AppCenterActions from '../actions/appcenter';
import * as AppActions from '../actions/app';
import * as TrackingActions from '../actions/tracking';
import { getUtmParams } from '../lib/helpers';
import {
  buildMainAggRankJsonString,
  buildCategoryAggRankJsonString
} from '../lib/fptiRecommendationHelper';

import {
  buildAppCenterVariables,
  setAppCenterWindowFeedback,
  optObjAttrsForAmplitudeCommon,
  optObjAttrsFromOptions,
  optObjAttrsFromTool,
  optObjAttrsCategoryRank,
  addlOptObjAttrsFptiClick,
  setAppCenterContainerAttributes,
  overrideOptObjFptiImpression,
  getCollectionFpti
} from '../lib/appCenterContainerHelper';

const PARTNERS = 'partners';

const mapStateToProps = (state, props = {}) => {
  const newPSData = get(state, 'appcenter.psData', {});
  const tools = getTools(state);
  const country = get(state, 'app.context.locale.country', '');
  const isLoggedIn = get(state, 'app.fptiData.lgin');
  const experimentation = get(state, 'experimentation');
  const merchantActivationState = get(
    state,
    'appcenter.merchantActivationState'
  );
  const productIntentTools = get(state, 'appcenter.productIntentTools', {});
  const collectionIntentBanners = get(
    state,
    'appcenter.collectionIntentBanners',
    {}
  );
  const quicklinks = {
    ...get(state, 'quicklinks', {}),
    appData: get(newPSData, 'details.DetailsHeader', {}),
    context: {
      csrf: get(state, 'app.csrf'),
      language: get(state, 'app.context.locale.language')
    }
  };
  const twofersIntelligentApps = get(
    state,
    'appcenter.twofersIntelligentApps',
    []
  );
  const args = {
    psData: newPSData,
    mtsData: tools,
    country,
    isLoggedIn,
    experimentation,
    productIntentTools,
    merchantActivationState,
    collectionIntentBanners,
    twofersIntelligentApps
  };

  const { flatData, structuredData } = filterPSData(args);
  const { searchModalExp, coloredIconsExp } = experimentation;
  const isSearchModalEligible = searchModalExp && coloredIconsExp;
  const pathname = props.location?.pathname || '';
  const comp = 'merchanthubnodeweb';

  const [, , categorySlug, detailsSlug] = pathname.split('/');

  const { tool, category, pgrp } = buildAppCenterVariables(flatData, {
    detailsSlug,
    categorySlug
  });

  // sets window feedback with global fpti data
  setAppCenterWindowFeedback(tool, pgrp);

  const getSubPage = pageLink =>
    pageLink && !pgrp.match(pageLink) ? `:${pageLink}` : '';

  const fptiClick = (options = {}) => {
    const { fptiLink = '', pageLink = '' } = options;
    const collectionFpti = getCollectionFpti(options);
    const container = {
      // add a colon only if link has length
      page: `${pgrp}${collectionFpti}${getSubPage(pageLink)}`,
      pgrp: `${pgrp}${!detailsSlug && !categorySlug ? '' : collectionFpti}`
    };

    const optionsObj = {
      custId: get(state, 'app.custId'),
      acct_cntry: get(state, 'app.legalCountry'),
      link: fptiLink,
      comp,
      ...addlOptObjAttrsFptiClick({ tool, options, pageLink, pathname })
    };

    // sets additional container attributes
    setAppCenterContainerAttributes(
      container,
      { pageLink },
      isSearchModalEligible
    );

    // records the click event
    recordClick(optionsObj, container);
  };

  const fptiImpression = (options = {}) => {
    const { pageLink = '' } = options;
    const collectionFpti = getCollectionFpti(options);
    const container = {
      // add a colon only if link has length
      // add link only if it is not in pgrp (this happens on category page for products)
      page: `${pgrp}${collectionFpti}${getSubPage(pageLink)}`,
      pgrp: `${pgrp}${!detailsSlug && !categorySlug ? '' : collectionFpti}`
    };

    const optionsObj = {
      custId: get(state, 'app.custId'),
      comp,
      acct_cntry: get(state, 'app.legalCountry'),
      // sets tools attributes
      ...optObjAttrsFromTool(tool),

      // sets category rank from options
      ...optObjAttrsCategoryRank(options),

      // sets category from options
      ...optObjAttrsFromOptions(options),

      ...(options.erpg && { erpg: options.erpg, eccd: options.eccd || 'code' }), // code signifies code error

      // if passed pageLink is 'partners'
      // categories and sections don't have prod . . .
      // IF prod is passed, it is a tool tile in partners
      // then add partner_name
      ...(pageLink === PARTNERS &&
        options.prod && { partner_name: options.prod }),

      // sets common amplitude attributes
      ...optObjAttrsForAmplitudeCommon(options)
    };

    // add aggregated rank object to Main Page impression
    if (!options.pageLink && !categorySlug && !detailsSlug) {
      optionsObj.rank = buildMainAggRankJsonString(
        flatData.defaultRecommended,
        structuredData
      );
    }
    // add aggregated rank object to a Category Page impression event
    if (!options.pageLink && category && categorySlug && !detailsSlug) {
      optionsObj.rank = buildCategoryAggRankJsonString(
        category,
        structuredData
      );
    }

    // any overrides go here
    overrideOptObjFptiImpression(optionsObj, {
      options,
      detailsSlug,
      category,
      tool,
      pathname
    });

    // records the impression event
    recordImpression({ ...optionsObj, ...getUtmParams() }, container);
  };

  return {
    app: get(state, 'app', {}),
    fptiClick,
    fptiImpression,
    seo: newPSData.seo,
    detailsContent: get(state, 'appcenter.detailsContent'),
    tools: tools,
    toolServFavorites: get(state, 'myapps.favorites', []),
    flatPSData: flatData,
    structuredPSData: structuredData,
    quicklinks: quicklinks,
    search: get(state, 'myapps.search', {}),
    appSearch: get(state, 'appcenter.appSearch', {}),
    experimentation
  };
};

const mapDispatchToProps = dispatch => ({
  ...AppCenterActions,
  ...MyAppsActions,
  ...AppActions,
  ...TrackingActions,
  dispatch
});

const Wrapper = dataFetcher(AppCenter, [MyAppsActions.fetchTools]);
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
